import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FiscalEnvironmentEnum } from 'src/app/domain/registration/enums/fiscal-environment.enum';
import { RegimeTypeEnum } from 'src/app/domain/registration/enums/regime-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import {
  BranchFiscalParameter,
  CustomerBranch,
  defaultFiscalParameter,
} from '../customer-branch.util';

@Component({
  selector: 'app-customer-fiscal-parameters-panel',
  templateUrl: './customer-fiscal-parameters-panel.component.html',
  styleUrls: ['./customer-fiscal-parameters-panel.component.sass'],
})
export class CustomerFiscalParametersPanelComponent {
  @Input() branches: CustomerBranch[] = [];
  @Input() typeCes: TypeCesEnum = TypeCesEnum.EDIT;
  @Output() branchesChange = new EventEmitter<CustomerBranch[]>();

  readonly regimes = Object.values(RegimeTypeEnum);
  readonly environments = Object.values(FiscalEnvironmentEnum);

  get readonly(): boolean {
    return this.typeCes === TypeCesEnum.SHOW;
  }

  isProduction(branch: CustomerBranch): boolean {
    return branch.fiscalParameter?.fiscalEnvironment === FiscalEnvironmentEnum.PRODUCTION;
  }

  update(localKey: string, patch: Partial<BranchFiscalParameter>): void {
    this.branchesChange.emit(
      this.branches.map((branch) => {
        if (branch.localKey !== localKey) return branch;
        return {
          ...branch,
          fiscalParameter: {
            ...defaultFiscalParameter(branch.fiscalParameter),
            ...patch,
          },
        };
      })
    );
  }
}
